import { FormikToggleSwitch } from "../../../../../../components/FormikFields/FormikToggleSwitch.js";
import { useSessionStorage } from "../../../../../../hooks/useSessionStorage.js";
import "react";
import { FormLayout, Icon, Modal } from "@therms/atalaya";
import { IoMdDownload } from "react-icons/io";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Events/shared/EventInteractive/EventDetails/components/DownloadEventsOptionsModal.tsx
var ValidationSchema = Yup.object().shape({
	showEventsRefs: Yup.boolean(),
	showInternalContent: Yup.boolean(),
	showLocationsRefs: Yup.boolean(),
	showLogEntriesRefs: Yup.boolean(),
	showRecordsRefs: Yup.boolean(),
	showReportsRefs: Yup.boolean(),
	showUsersRefs: Yup.boolean(),
	withComments: Yup.boolean(),
	withRefHistory: Yup.boolean()
});
var initialValues = {
	showEventsRefs: false,
	showInternalContent: false,
	showLocationsRefs: false,
	showLogEntriesRefs: false,
	showRecordsRefs: false,
	showReportsRefs: false,
	showUsersRefs: false,
	withComments: false,
	withRefHistory: false
};
function DownloadEventsOptionsModal({ closeHandler, onDownload }) {
	const [sessionValue, setSessionValue] = useSessionStorage("downloadEventOptions");
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler,
		escPressClose: true,
		header: "Download Event",
		outsideClickClose: true,
		width: "sm",
		children: /* @__PURE__ */ jsx(Formik, {
			initialValues: sessionValue || initialValues,
			onSubmit: (values) => {
				setSessionValue(values);
				onDownload(values);
			},
			ValidationSchema,
			children: ({ handleSubmit, values }) => /* @__PURE__ */ jsxs(FormLayout, {
				space: "xs",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "font-bold",
						children: "PDF Details"
					}),
					/* @__PURE__ */ jsx(FormikToggleSwitch, {
						active: values.withComments,
						name: "withComments",
						label: /* @__PURE__ */ jsx("div", {
							className: "text-color",
							children: "Would you like to include comments in the file?"
						})
					}),
					/* @__PURE__ */ jsx(FormikToggleSwitch, {
						active: values.showInternalContent,
						name: "showInternalContent",
						label: /* @__PURE__ */ jsx("div", {
							className: "text-color",
							children: "Include Internal Content?"
						})
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "mt-base",
						children: [
							/* @__PURE__ */ jsx("div", {
								className: "font-bold",
								children: "References"
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.withRefHistory,
								name: "withRefHistory",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include the Reference History?"
								}),
								subText: "Include a timestamped list of all references for this Event."
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showEventsRefs,
								name: "showEventsRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include Event References?"
								})
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showLocationsRefs,
								name: "showLocationsRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include Location References?"
								})
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showLogEntriesRefs,
								name: "showLogEntriesRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include Log Entries References?"
								})
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showRecordsRefs,
								name: "showRecordsRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include Record References?"
								})
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showReportsRefs,
								name: "showReportsRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include Report References?"
								})
							}),
							/* @__PURE__ */ jsx(FormikToggleSwitch, {
								active: values.showUsersRefs,
								name: "showUsersRefs",
								label: /* @__PURE__ */ jsx("div", {
									className: "text-color",
									children: "Include User References?"
								})
							})
						]
					}),
					/* @__PURE__ */ jsx("div", {
						className: "mt-sm",
						children: /* @__PURE__ */ jsx(FormLayout.Controls, {
							onSubmit: handleSubmit,
							submitLabel: /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Icon, {
								Icon: IoMdDownload,
								className: "mr-xxs",
								size: "sm"
							}), "Download"] })
						})
					})
				]
			})
		})
	});
}
//#endregion
export { DownloadEventsOptionsModal };

//# sourceMappingURL=DownloadEventsOptionsModal.js.map